import { render, staticRenderFns } from "./ListarServico.vue?vue&type=template&id=4c71d6b8"
import script from "./ListarServico.vue?vue&type=script&lang=js"
export * from "./ListarServico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports